import { UserAgentHelper } from '@/helper/userAgentHelper';

const enum AppPlatformID {
    Web = 3,
    Desktop = 4,
}

class AppPlatform {
    public readonly id: AppPlatformID;

    constructor(id: AppPlatformID) {
        this.id = id;
    }
}

function getPlatformId() {
    if (UserAgentHelper.isElectron()) {
        return AppPlatformID.Desktop;
    }
    return AppPlatformID.Web;
}

const platform = new AppPlatform(getPlatformId());
export default platform;
